
/**
 * @class Version
 * @description
 * A class to handle semantic versioning and comparisons
 */
export default class Version {
    #major;
    #minor;
    #patch;
    #label;

    //add optional variable here to store function that modifies a state?

    // use onBlur to set this to avoid overflowing it when label is changed?
    #history;

    /**
     * @param {string} inputVersion
     */
    constructor(inputVersion) {
        this.#setVersion(inputVersion);
        this.#history = [];
    }

    /**
     * @description
     * Returns the version number
     * @return {string}
     */
    get version(){
        //console.log(this)
        return `${this.#major}.${this.#minor}.${this.#patch}` + (this.#label ? `-${this.#label}`:'')
    }

    /**
     * @param {string} inputVersion
     * @description
     * Sets the version number
     */
    set version(inputVersion){
        this.#setVersion(inputVersion);
    }

    /**
     * @return {Array}
     */
    get history(){
        return this.#history;
    }

    /**
     * @param {string} inp
     */
    set label(inp){
        this.#label = inp;
    }

    /**
     * @return {string}
     */
    get label(){
        return this.#label;
    }

    /**
     * @return {number}
     */
    get major(){
        return this.#major
    }

    /**
     * @return {number}
     */
    get minor(){
        return this.#minor
    }

    /**
     * @return {number}
     */
    get patch(){
        return this.#patch
    }

    #setVersion(inputVersion){


        //verify NaN??
        //verify against schema?

        const mmp = inputVersion.split('.');
        if (mmp.length !== 3) { console.warn('Invalid Version Input'); return undefined; }

        const pl = mmp[2].split('-');

        // <major>.<minor>.<patch>-<label>
        this.#major = parseInt(mmp[0]);
        this.#minor = parseInt(mmp[1]);
        this.#patch = parseInt(pl[0]);
        this.#label = pl[1] ? pl[1] : '';
    }


    /**
     * @description
     * Increments the major version number by one
     */
    revMajor(){
        this.#recordChange();

        this.#major++;
        this.#minor = 0;
        this.#patch = 0;
    }
    
    /**
     * @description
     * Increments the minor version number by one
     */
    revMinor(){
        this.#recordChange();

        this.#minor++;
        this.#patch = 0;
    }

    /**
     * @description
     * Increments the patch version number by one
     */
    revPatch(){
        this.#recordChange();   

        this.#patch++;
    }

    undoRev(){
        const prev = this.#history.pop();

        console.log(prev)

        //if history is empty, return;
        if (!prev){return;}

        this.#major = prev.major;
        this.#minor = prev.minor;
        this.#patch = prev.patch;
    }

    #recordChange(){
        this.#history.push({major:this.#major, minor:this.#minor, patch:this.#patch})

        if(this.history.length > 5){
            this.#history.shift();
        }

        console.log(this)
    }

    /**
     * @param {(string|Version)} inpVer
     */
    compare(inpVer){
        switch (typeof inpVer){
            case "string":
                return this.#compareString(inpVer)
            case "object":
                // if it's not an instance of Version it falls through to 'default'
                if(inpVer instanceof Version){return this.#compareVersion(inpVer);}
                break;
            default:
                return null;
        }
    }


    /**
     * @param {string} inpVer
     */
    #compareString(inpVer){
        const mmp = inpVer.split('.');
        const pl = mmp[2].split('-');
        
        const major = parseInt(mmp[0]);
        const minor = parseInt(mmp[1]);
        const patch = parseInt(pl[0]);

        // Only execute comparisons for minor and patch if the previous is equal
        // This indicates a priority for numbers higher in the chain
        let comp = this.#numCompare(major, this.#major);
        if(comp === 0){comp = this.#numCompare(minor, this.#minor);}
        if(comp === 0){comp = this.#numCompare(patch, this.#patch);}
        return comp;
    }

    /**
     * @param {Version} inpVer
     */
    #compareVersion(inpVer){

        // Only execute comparisons for minor and patch if the previous is equal
        // This indicates a priority for numbers higher in the chain
        let comp = this.#numCompare(inpVer.major, this.#major);
        if(comp === 0){comp = this.#numCompare(inpVer.minor, this.#minor);}
        if(comp === 0){comp = this.#numCompare(inpVer.patch, this.#patch);}
        return comp;
    }

    /**
     * @param {number} a
     * @param {number} b
     * @returns {number}
     * 1 = 'a' is greater
     * 0 = equal
     * -1 = 'b' is greater
     */
    #numCompare(a, b){
        //return a-b/abs(a-b) ?

        if (a > b) { return 1 }
        if (a === b) { return 0 }
        if (a < b) { return -1 }
    }

    //TODO: add compare that returns results based on individual major/minor/patch differences
}